<template>
  <div>
    <div class="centered-header">
      <h4 class="ui header" style="color: #092442;">
        <i class="pills icon"></i>
        <div class="content">
          Prescription
        </div>
      </h4>
    </div>
    <div class="ui divider"></div>
    <div v-if="componentPrescription && componentPrescription.prescription_items.length > 0 ">
        <div class="ui primary button" style="background-color: #092442"
             @click="showModal()" v-if="canAdd">
          {{ $t('addMedicine') }}
        </div>
      <abstractTable :columns="prescriptionColumns" :data="apiPrescriptionItems()"
                     :classes="'ui very compact left aligned celled table'">
      </abstractTable>
    </div>

    <div v-else>
      <div class="ui placeholder segment" style="margin-bottom: 50px">
        <div class="ui icon header" style="color: #092442">
          <i class="dont icon"></i>
          {{ $t('noPrescriptionHaveBeenMadeYet') }}
        </div>
        <div class="ui primary button" style="background-color: #092442"
             @click="showModal()" v-if="canAdd">
          {{ $t('addPrescription') }}
        </div>
      </div>
    </div>

    <div class="ui large longer modal" :id="'prescription-' + reservationVisitId" style="margin-top: 20px !important;">
      <div class="header">{{ $t('addPrescription') }}</div>
      <div class="centered-header" style="color: red; padding-top:10px;" v-if="error">{{ error }}</div>
      <div class="scrolling content">
        <inputTable :columns="prescriptionColumns"
                    :objectProps="prescriptionProps"
                    :objectArray="objectArray"
                    @onChange="prescriptionEventListenner"
                    :clearData="wantToClear">
        </inputTable>

      </div>
      <div class="actions">
        <div class="ui button"
             @click="hideModal()">
          {{ $t('discard') }}
        </div>

        <div class="ui blue button"
             style="background-color: #092442"
             @click="save()">
          {{ $t('save') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    abstractTable: require('@/components/abstract_components/AbstractTable').default,
    inputTable: require('@/components/abstract_components/InputTable').default
  },
  props: {
    prescription: { type: Object, default: () => { prescription_items: [] } },
    reservationVisitId: { type: Number, required: true },
    canAdd: { type: Boolean, default: false }
  },
  data () {
    return {
      wantToClear: false,
      error: null,
      prescriptionProps: {
        baiscProps: [
          {
            name: 'medicine',
            defaultValue: ''
          },
          {
            name: 'description',
            defaultValue: ''
          }
        ],
        widths: {
          medicine: '20%',
          description: '80%'
        },
        inputType: {
          medicine: 'text',
          description: 'text'
        },
        placeholder: {
          medicine: this.$t('medicine'),
          description: this.$t('description')
        }
      },
      objectArray: [
        {
          medicine: '',
          description: ''
        }
      ],
      prescriptionItems: [],
      componentPrescription: {
        prescription_items: []
      }
    }
  },
  computed: {
    prescriptionColumns () {
      return [
        { header: this.$t('medicine'), fieldName: 'medicine', show: true, width: '25%' },
        { header: this.$t('description'), fieldName: 'description', show: true }
      ]
    }
  },
  mounted () {
    if (this.prescription) {
      this.componentPrescription = window._.cloneDeep(this.prescription)
    }
  },
  methods: {
    apiPrescriptionItems () {
      let formalatedPrescriptionItems = []

      window._.each(this.componentPrescription.prescription_items, prescriptionItem => {
        formalatedPrescriptionItems.push({
          medicine: prescriptionItem.medicine_name,
          description: prescriptionItem.description
        })
      })

      return formalatedPrescriptionItems
    },
    showModal () {
      $('#prescription-' + this.reservationVisitId).modal('show')
    },
    prescriptionEventListenner (event) {
      this.prescriptionItems = event.data
    },
    hideModal () {
      $('#prescription-' + this.reservationVisitId).modal('hide')
      this.wantToClear = true
      this.$nextTick(() => {
        this.wantToClear = false
      })
    },
    save () {
      let listWithoutNullValues = window._.filter(this.prescriptionItems, prescriptionItem => {
        return prescriptionItem.medicine
      })

      let items = window._.map(listWithoutNullValues, prescriptionItem => {
        return {
          medicine_name: prescriptionItem.medicine,
          description: prescriptionItem.description
        }
      })

      let dataToBeSaved = {
        reservation_id: this.reservationVisitId,
        prescription_items: items
      }

      if (dataToBeSaved.prescription_items && dataToBeSaved.prescription_items.length) {
        this.$http.post(`reservation_visits/${this.reservationVisitId}/add/prescription`, {
          prescription: dataToBeSaved,
          clinic_id: this.getClinicId()
        }).then(response => {
          this.componentPrescription = response.data
          this.$emit('prescription-change', {
            data: {
              prescription: response.data
            }
          })
          this.hideModal()
        })

      } else {
        this.error = 'Please insert a medicine with a description'
      }
    }
  }
}
</script>

<style scoped>
.centered-header {
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/visits/visit_components/PrescriptionPart.vue